__turbopack_context__.v({
  "accordionTitle": "ReviewBody-module__Zwjb7q__accordionTitle",
  "accordionWrapper": "ReviewBody-module__Zwjb7q__accordionWrapper",
  "body": "ReviewBody-module__Zwjb7q__body",
  "does-not-exist": "ReviewBody-module__Zwjb7q__does-not-exist",
  "img": "ReviewBody-module__Zwjb7q__img",
  "imgPlaceholder": "ReviewBody-module__Zwjb7q__imgPlaceholder",
  "js-has-pseudo": "ReviewBody-module__Zwjb7q__js-has-pseudo",
  "mainSection": "ReviewBody-module__Zwjb7q__mainSection",
  "mainSectionWrapper": "ReviewBody-module__Zwjb7q__mainSectionWrapper",
  "reviewImage": "ReviewBody-module__Zwjb7q__reviewImage",
  "summary": "ReviewBody-module__Zwjb7q__summary",
  "wrapper": "ReviewBody-module__Zwjb7q__wrapper",
});
